<span class="view-workflow-button" *ngIf="showProgressTracker">
  <app-button [disable]="disableButton" [name]="'View '+ dashboardName" [textTransformNone]="true" [type]="'primary'" (btnClick)="goToWorkflowDashboard()"></app-button>
</span>
